<template>
  <v-dialog
    v-if="value"
    :value="value" @input="input => $emit('input', input)"
    persistent
    width="1000px"
  >
    <v-card class="pa-10">
      <div class="d-flex align-center">
        <span class="text-h6 font-weight-bold">Escolha a origem da sua imagem:</span>
        <div style="width: 200px;">
          <v-select
            class="ml-3"
            :items="['URL da imagem', 'Upload', 'Unsplash']"
            v-model="origin"
            hide-details
            outlined
            dense
          ></v-select>
        </div>
        <v-spacer></v-spacer>
        <v-btn depressed @click="$emit('input', false)">
          cancelar
        </v-btn>
      </div>
      <div class="mt-5">
        <zp-upload v-if="origin === 'Upload'" v-bind="$attrs" v-on="$listeners"></zp-upload>
        <zp-image-url v-if="origin === 'URL da imagem'" v-bind="$attrs" v-on="$listeners"></zp-image-url>
        <zp-unsplash v-if="origin === 'Unsplash'" v-bind="$attrs" v-on="$listeners"></zp-unsplash>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ZpUpload from './Upload.vue'
import ZpImageUrl from './ImageURL.vue'
import ZpUnsplash from './Unsplash.vue'

export default {
  props: ['value'],
  components: {
    ZpUpload,
    ZpImageUrl,
    ZpUnsplash
  },
  data () {
    return {
      origin: 'Upload'
    }
  }
}
</script>

<style lang="scss" scoped>

</style>